// Lib
import React from 'react';

type Props = {
    error: object;
};

/**
 * This component will be shown when a "synced action" doesn't have any channels to send to.
 * It should only get shown in debug modes (debug enabled or non-prod environments).
 */
const SocketNoChannelsErrorContent: React.FC<Props> = () => (
    <>
        <h2>Sync error [DEBUG ONLY]</h2>
        <div>
            <p>An action was unable to sync as no channels were found</p>
        </div>
        <div className="section">
            <p>This error should only get shown in debug environments.</p>
            <p>Open up the developer console to inspect the action details that caused this error.</p>
        </div>
    </>
);

export default SocketNoChannelsErrorContent;
